<div>
  <div class="row">
    <div class="offset-lg-2"></div>
    <div class="col-lg-8">
      <form [formGroup]="form" (submit)="submit()">
        <div formGroupName="customer">
          <div class="card">
            <div class="card-header">Policy</div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="name">Number</label>
                    <input type="text" class="form-control" formControlName="policyNumber" />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="name">Effective Date</label>
                    <input
                      formControlName="policyEffectiveDate"
                      class="form-control"
                      bsDatepicker
                      [bsConfig]="dateConfig" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card">
            <div class="card-header">Customer</div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="name">Customer name</label>
                    <input type="text" class="form-control" formControlName="customerName" />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="name">Contact name</label>
                    <input type="text" class="form-control" formControlName="contactName" />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="name">Customer email</label>
                    <input type="text" class="form-control" formControlName="contactEmail" />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="name">Customer mobile</label>
                    <input type="text" class="form-control" formControlName="contactPhone" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div formGroupName="locations">
          <div class="card">
            <div class="card-header">Location</div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="name">Address</label>
                    <input type="text" class="form-control" formControlName="address" />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="name">City</label>
                    <input type="text" class="form-control" formControlName="city" />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="name">State</label>
                    <input type="text" class="form-control" formControlName="state" />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="name">Zip</label>
                    <input type="number" class="form-control" formControlName="zip" />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="name">Due Date</label>
                    <input
                      formControlName="dueDate"
                      class="form-control"
                      bsDatepicker
                      [ngClass]="getValidationClass('locations', 'dueDate')"
                      [bsConfig]="dateConfig" />
                  </div>
                </div>
              </div>

              <div class="col-lg-10 col-md-8 pr-0">
                <div class="row">
                  <label for="name">Items to inspect</label>
                </div>
                <div class="row">
                  <div class="col-md-12 form-group">
                    <table class="items-table col-md-12">
                      <thead>
                        <div class="row">
                          <div class="col-md-2 header">Item Type</div>
                          <div class="col-md-2 header">Quantity</div>
                          <div class="col-md-2 header">Custom Names</div>
                          <div class="col-md-6"></div>
                        </div>
                      </thead>
                      <tbody>
                        <div *ngFor="let info of form.get('locations.items').value">
                          <div class="row">
                            <div class="col-md-2 column">{{ info.item?.name }}</div>
                            <div class="col-md-2 column">
                              <input
                                class="form-control"
                                [formControl]="info.quantity"
                                type="number"
                                style="width: 65px" />
                            </div>

                            <div *ngIf="info.customNames" class="col-md-2 column">
                              <div class="custom-control custom-switch">
                                <input
                                  disabled
                                  type="checkbox"
                                  class="custom-control-input"
                                  [formControl]="info.customNames"
                                  [id]="'customSwitch' + (info.id || info.item?.id)" />
                                <label
                                  class="custom-control-label"
                                  [for]="'customSwitch' + (info.id || info.item?.id)"></label>
                              </div>
                            </div>

                            <div class="col-md-6" *ngIf="!info.customNames?.value"></div>

                            <div class="col-md-6 pl-0 column" *ngIf="info.customNames?.value">
                              <ng-container *ngFor="let name of info.namesInputs; index as i">
                                <input
                                  class="form-control"
                                  style="margin-bottom: 10px"
                                  [placeholder]="info?.item?.name + ' #' + (i + 1)"
                                  [formControl]="name" />
                              </ng-container>
                            </div>
                          </div>
                        </div>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="name">Notes</label>
                    <textarea class="form-control" formControlName="notes"></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div formGroupName="vendor">
          <div class="card">
            <div class="card-header">Inspector</div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="name">Assign to inspector</label>
                    <ng-select
                      [items]="inspectorDataSource"
                      bindLabel="name"
                      [trackByFn]="inspectorTrackByFn"
                      (change)="onInspectorSelect($event)"
                      formControlName="inspector"
                      (focusout)="handleDropdownClose()"
                      (clear)="clearInspector()">
                      <ng-template ng-option-tmp let-item="item">
                        <div class="d-flex justify-content-between">
                          <span>
                            {{ item.name }}
                            <small *ngIf="item.distanceInMiles"> ({{ item.distanceInMiles }})</small>
                          </span>
                          <span>
                            <small class="pr-6" *ngIf="item.distanceInMiles"
                              >Open Inspections: {{ item.assignmentMadeCount }}</small
                            >
                          </span>
                        </div>
                      </ng-template>

                      <ng-template ng-label-tmp let-item="item">
                        <div>
                          {{ item.name }}
                          <small *ngIf="item.distanceInMiles"> ({{ item.distanceInMiles }})</small>
                        </div>
                      </ng-template>
                      <ng-template ng-footer-tmp>
                        <a *ngIf="!viewMoreClicked" (click)="viewMoreInspectors()" class="view-more-link">View more</a>
                      </ng-template>
                      <ng-template ng-not-found> No inspectors found. </ng-template>
                    </ng-select>
                    <p class="text-danger" *ngIf="inspectorMismatch">
                      This Inspector doesn’t match the inspection’s product type. Proceed anyway?
                    </p>
                  </div>
                </div>
              </div>
              <div *ngIf="showSaveButton" class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <button class="btn btn-primary" [disabled]="!form.valid">Save</button> &nbsp;
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
